import { FC } from "react";
import { Input } from "antd";
import Carrier from "@Components/Carrier/Carrier";
import AppDateCalendar from "@Components/AppDateCalendar/AppDateCalendar";
import { withFloatingLabel } from "src/HOC";
import { formatDate } from "src/utility/time";
import { CalendarIcon } from "src/assets/Icons";
import { PassengerDateFieldProps } from "../PassengerDateField";

const FloatingInput = withFloatingLabel(Input);
const DATE_FORMAT = "ddd, DD MMM YYYY";

const PassengerDateFieldMob: FC<PassengerDateFieldProps> = ({ value, onChange, label, disabledDate, className }) => {
  return (
    <Carrier
      label={label}
      renderTrigger={({ open }) => (
        <div className={`border-border-default text-font-subtle flex w-full flex-1 items-center gap-1 border-b px-1 ${className ?? ""}`}>
          <CalendarIcon className="h-4! w-4!" />
          <Input
            placeholder={label}
            readOnly
            variant="borderless"
            value={formatDate(value, DATE_FORMAT)}
            onClick={open}
            className="text-font-default! shadow-none! px-3! py-2! w-full cursor-pointer font-semibold"
          />
        </div>
      )}
      renderSheet={({ close }) => (
        <div className="flex h-full flex-col p-4">
          <div className="gap-2! outline-border-default focus-within:outline-border-active mb-4! py-2! flex shrink-0 items-center justify-center rounded-md px-4 outline">
            <div>
              <CalendarIcon className="h-5 w-5 text-current" />
            </div>
            <FloatingInput
              label={label}
              readOnly
              value={formatDate(value, DATE_FORMAT)}
              variant="borderless"
              className="pt-6! pb-2! px-3! font-semibold"
            />
          </div>

          <AppDateCalendar value={value} onChange={onChange} onSelected={close} shouldDisableDate={disabledDate} autoFocus />
        </div>
      )}
    />
  );
};

export default PassengerDateFieldMob;
